<template>
  <div>
    <a-form :form="form" class="headForm" labelAlign="left" style="margin-top: 10px;">
      <a-row :gutter="24">
        <a-col :span="5">
          <a-form-item label="客户名称">
            <a-input
              @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
              v-decorator="['customerName']" placeholder="请输入客户名称"
            />
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="片区/聚落">
            <a-select
              show-search
              v-decorator="['settlementId']"
              placeholder="请选择片区/聚落"
              :filter-option="(input, option) => {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }"
            >
              <a-select-option v-for="el in deptList" :key="el.deptId" :value="el.deptId">{{ el.deptName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="填报人">
            <a-input
              @pressEnter="getList({current:1,pageSize:pagination.pageSize})"
              v-decorator="['userName']" placeholder="请输入客户名称"
            />
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="选择日期">
            <a-range-picker v-decorator="['time']" />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item >
            <a-space>
              <a-button type="primary" @click="getList({current:1,pageSize:pagination.pageSize})">查询</a-button>
              <a-button @click="resetForm">清空</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="tableBox">
      <div style="margin-bottom: 10px;">
        <a-button type="primary" @click="newValues">新建</a-button>
        <a-button style="margin-left: 10px;" @click="exportList" :loading="btnLoading">数据导出</a-button>
      </div>
      <a-table
        ref="listRef"
        row-key="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :scroll="{x: 100}"
        bordered
      >
        <template slot="name" slot-scope="t">
          <a-tooltip>
            <template slot="title">{{ t }}</template>
            {{ t }}
          </a-tooltip>
        </template>
        <a-tooltip slot="fixed2" slot-scope="t">
          <template slot="title">{{ t || t === 0 ? Number(t).toFixed(2) : t }}</template>
          {{ t || t === 0 ? Number(t).toFixed(2) : t }}
        </a-tooltip>
        <template slot="time" slot-scope="t,r">
          <a-tooltip>
            <template slot="title">{{ r.intoDay }} 至 {{ r.outDay }}</template>
            {{ r.intoDay }} 至 {{ r.outDay }}
          </a-tooltip>
        </template>
        <template slot="x" slot-scope="t,r">
          <a-space>
            <a @click="openDetail(r)">详情</a>
            <a @click="copyValues(r)">复制</a>
          </a-space>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import api from './api'
import moment from 'moment'
import {columnsRuminate} from './Columns'
export default {
  components: {},
  props: {},
  data() {
    return {
      btnLoading: false,
      list: [],
      form: this.$form.createForm(this),
      columns: columnsRuminate,
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `总共${total}个记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      deptList: []
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.getInfo()
    this.getList()
  },
  methods: {
    settime(){
      setTimeout(() => {
        this.getList({current:1,pageSize:this.pagination.pageSize})
      }, 0);
    },
    async getList(pagination){
      this.form.validateFields(async (error, values) => {
        let {current=1,pageSize=20} = pagination || this.pagination
        let {time,...newValues} = values || {}
        let params = {
          current,size:pageSize,
          startTime: time && time.length > 0 ? moment(time[0]).format('YYYY-MM-DD 00:00:00') : undefined,
          endTime: time && time.length > 0 ? moment(time[1]).format('YYYY-MM-DD 23:59:59') : undefined,
          ...newValues,
          lineType: 'RUMINATION_LINE',
          controlRight: true,
        }
        let res = await api.getPigList(params)
        let {success,data} = res || {}
        if(success){
          let {records,current=1,total=0} = data;
          this.pagination.current = current
          this.pagination.total = total
          this.list = records || []
        }
      });
    },
    async getInfo(){
      // let dept = await api.deptList()
      // this.deptList = dept.data || []
      let res = await api.deptTree()
      let dept = {}
      await this.getDeptList(res.data || [],dept)
      this.deptList = dept.data
    },
    getDeptList(list,dept){
      list && list.forEach(el => {
        if(el.children){
          if(el.title === '饲料BU'){
            if(el.children){
              el.children = el.children.map(item => {
                return {
                  deptId: item.id,
                  deptName: item.title
                }
              })
              dept.data = el.children || []
            }
          }else{
            this.getDeptList(el.children,dept)
          }
        }
      })
    },
    resetForm(){
      this.form.resetFields();
    },
    newValues(){
      this.$router.push({
        path: '/empirical-data/ruminate/ruminate-new-data',
        query: {
          name: '反刍线路新建',
        }
      })
    },
    copyValues(record){
      this.$router.push({
        path: '/empirical-data/ruminate/ruminate-copy-data',
        query: {
          name: '反刍线路复制',
          copyId: record.recordId,
        }
      })
    },
    openDetail(record){
      this.$router.push({
        path: '/empirical-data/ruminate/ruminate-detail',
        query: {
          name: '反刍线路详情',
          id: record.recordId,
        }
      })
    },
    exportList(){
      this.form.validateFields(async (error, values) => {
        let {time,...newValues} = values || {}
        let params = {
          startTime: time && time.length > 0 ? moment(time[0]).format('YYYY-MM-DD 00:00:00') : undefined,
          endTime: time && time.length > 0 ? moment(time[1]).format('YYYY-MM-DD 23:59:59') : undefined,
          ...newValues,
          lineType: "RUMINATION_LINE",
          controlRight: true,
        }
        this.btnLoading = true
        await api.exportExcel(params)
        this.btnLoading = false
      });
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>